import { useState } from 'react';
import Breadcrumbs from '../../components/Breadcrumbs';
import '../../styles/Access.css';
import { permissionicon, usersIcon } from '../../utils/svgs';
import PermissionGroup from './PermissionGroup';
import Users from './Users';

const Access = () => {
    const [activeTab, setActiveTab] = useState('users');

    return (
        <div>
            <Breadcrumbs values={['Access Management', activeTab === 'users' ? 'Users' : 'Permissions Group']} />

            <div className='access_view'>
                <h2>{activeTab === 'users' ? 'Users' : 'Permissions Group'}</h2>

                <div className='access_btn'>
                    <button onClick={() => setActiveTab('users')} className={activeTab === 'users' ? 'active' : ''}>{usersIcon} Users</button>
                    <button onClick={() => setActiveTab('permissions')} className={activeTab === 'permissions' ? 'active' : ''}>{permissionicon} Permissions Group</button>
                </div>
            </div>

            {
                activeTab === 'users' ? <Users /> :
                    <PermissionGroup />
            }
        </div>
    )
}

export default Access